import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { AdminPendingMealPlanTable } from "./AdminPendingMealPlanTable";

import { adminMealPlanServices } from "./service/adminMealPlan.service";


class ManagePendingMealPlanTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fetching: false,
            submitting: false,
            formError: null,
            data: null,
            selectedRow: null,
            hasParams: false,
            error: null,
            pageNum: 0,
            pageSize: 10,
            pages: null,
            showModal: false,
            notResetMode: false,
            //   status: "DRAFT",
        };
    }
    componentDidMount() {
        const { pageNum, pageSize } = this.state;
        this.getPendingMealPlans({ "page-num": pageNum + 1, "page-size": pageSize });
    }

    getPendingMealPlans = async (params) => {
        try {
            this.setState({ fetching: true });
            let response = await adminMealPlanServices.getAllPendingFoodItems(params);
            if (response) {
              
                this.setState({
                    data: response,
                    pages: Math.ceil(response.count / params["page-size"]),
                    error: null,
                    fetching: false,
                });
            }
        } catch (error) {
            this.setState({ error, fetching: false });
        }
    };

    fetchData = () => {
        const { pageNum, pageSize, filterParams } = this.state;
        let params = { "page-num": pageNum + 1, "page-size": pageSize };
        if (filterParams) {
            params = { ...filterParams, ...params };
        }
        this.getPendingMealPlans(params);
    };

    setPageNumber = (pageIndex) => {
        this.setState({ pageNum: pageIndex }, () => this.fetchData());
    };

    setPageSize = (pageSize, pageIndex) => {
        this.setState({ pageSize, pageNum: pageIndex }, () => this.fetchData());
    };

    filterData = (params) => {
        this.setState({ filterParams: params, pageNum: 0 }, () => this.fetchData());
    };

    selectRow = (selectedRow) => {
        this.setState({ selectedRow: selectedRow.original, hasParams: true });
    };

    render() {
        const { fetching, data, pages, pageNum, pageSize, error, hasParams, selectedRow } = this.state;

        return (
            <Row>
                <Col sm="12">
                    <AdminPendingMealPlanTable
                        fetching={fetching}
                        hasParams={hasParams}
                        selectedRow={selectedRow}
                        data={data}
                        selectRow={this.selectRow}
                        error={error}
                        showModal={this.showConfirmation}
                        pages={pages}
                        page={pageNum}
                        pageSize={pageSize}
                        filterData={this.filterData}
                        setPageNumber={this.setPageNumber}
                        setPageSize={this.setPageSize}
                        postId={selectedRow}
                        routeChange={this.routeChange}
                    />
                </Col>
            </Row>
        );
    }
}

export default ManagePendingMealPlanTable;
